module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.showPopupLoading),
      expression: "showPopupLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "popup",
    class: _vm.showHeader ? 'header-pop' : '',
    style: ('opacity: ' + _vm.popupOpacity)
  }, [(_vm.showHeader) ? _c('div', {
    staticClass: "header",
    class: _vm.title ? '' : 'no-border-bottom'
  }, [(_vm.title) ? _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.showHeader) ? _c('i', {
    staticClass: "el-icon-circle-cross close popup-close",
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: _vm.isWidth ? 'width-content' : 'narrow-content'
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4275b589!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partial/Popup.vue
// module id = 78
// module chunks = 0 4